import ComponentModule from "@eisinc/Overrides/Components/ProductSelector";

export * from "@eisinc/Overrides/Components/ProductSelector";

export default ComponentModule;
